import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("data_quality.p_validation_type"))),
      ]),
      _c(
        "actions-component",
        [
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs["form-tabla"].showModal(false, "create")
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-add")]),
                  _vm._v(_vm._s(_vm.$t("btns.create"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("profiling-table-parameters", {
        ref: "form-tabla",
        attrs: {
          fields: _vm.fields,
          deleteValidationType: true,
          modalName: _vm.$t("data_quality.validation_type"),
        },
      }),
      false
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("b-pagination", {
                    attrs: {
                      "total-rows": _vm.rows,
                      "per-page": _vm.perPage,
                      "aria-controls": "main-table",
                      size: "sm",
                      align: "center",
                    },
                    model: {
                      value: _vm.currentPage,
                      callback: function ($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }